export default "__VITE_ASSET__B8I$Qb2X__"